/**
 * Smooth deterministic fields for generation. Kept separate from the RNG so a
 * field can be sampled in any order without disturbing the stream, which lets
 * placement passes iterate cells however they like and stay reproducible.
 */

import { hash2, lerp } from '../../core/math';

/** Value noise in [0, 1). One unit of x/y is one lattice cell. */
export function valueNoise2(x: number, y: number, seed: number): number {
  const xi = Math.floor(x);
  const yi = Math.floor(y);
  const xf = x - xi;
  const yf = y - yi;
  const u = xf * xf * (3 - 2 * xf);
  const v = yf * yf * (3 - 2 * yf);
  const a = hash2(xi, yi, seed);
  const b = hash2(xi + 1, yi, seed);
  const c = hash2(xi, yi + 1, seed);
  const d = hash2(xi + 1, yi + 1, seed);
  return lerp(lerp(a, b, u), lerp(c, d, u), v);
}

/** Two octaves of value noise, normalised to [0, 1). */
export function fbm2(x: number, y: number, seed: number): number {
  return (valueNoise2(x, y, seed) * 2 + valueNoise2(x * 2.13, y * 2.13, seed ^ 0x9e37)) / 3;
}
